import { render } from "./LoginBox.vue?vue&type=template&id=11016a7c"
import script from "./LoginBox.vue?vue&type=script&lang=js"
export * from "./LoginBox.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/timetake.de/timetake/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__